import React from 'react';
import { Button } from './ui/button';
import { ctaSection } from '../mock/data';

const CTA = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-r from-green-700 via-green-800 to-green-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
          {ctaSection.title}
        </h2>
        <p className="text-xl text-green-100 mb-8 leading-relaxed">
          {ctaSection.subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            className="bg-white text-green-800 hover:bg-gray-100 px-8 py-3 text-lg font-semibold transition-all hover:scale-105 shadow-lg"
            onClick={() => {
              const pricingSection = document.querySelector('[data-section="pricing"]');
              if (pricingSection) {
                pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
          >
            Subscribe Today
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;